import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Chip from '@material-ui/core/Chip';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Done from '@material-ui/icons/Done';
import DonutLarge from '@material-ui/icons/DonutLarge';
import MeetingRoomTwoTone from '@material-ui/icons/MeetingRoomTwoTone';
import React, { FC } from 'react';
import { GameStatus, roundStatusIconMap } from './Game';
import { useGame, usePlayer, useRoom, useRound } from './hooks';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

type ScreenProps = {
  title: string,
  hideBreadcrumbs?: boolean,
};

export const Screen: FC<ScreenProps> = ({ title, hideBreadcrumbs, children }) => {
  const { player } = usePlayer();
  const { room, leaveRoom } = useRoom();
  const { game } = useGame();
  const { round } = useRound();
  const RoundStatusIcon = round?.status && roundStatusIconMap[round.status];
  const GameStatusIcon = game?.get('status') === GameStatus.RUNNING ? DonutLarge : Done;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<Element | null>(null);
  const open = Boolean(anchorEl);
  const handleMenu = (event: { currentTarget: Element }) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Container maxWidth="sm">
      <AppBar className={classes.root} position="static">
        <Toolbar>
          <Tooltip title={title}>
            <Typography variant="h6" className={classes.title} style={{ fontFamily: 'Cinzel Decorative' }}>
              Nua Oans
            </Typography>
          </Tooltip>
          {round && round?.guesser && player &&
          <Typography className={classes.title}>
            {round.guesser.isEqual(player.ref) ? 'Ratender' : 'Hinweisgeber'}
          </Typography>
          }
          {round && round?.moderator && player && round.moderator.isEqual(player.ref) &&
          <Typography className={classes.title}>
            Moderator
          </Typography>
          }
          {player?.exists
            ?
            <div>
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <Avatar src={player.get('avatar')}>
                  {player.get('name')}
                </Avatar>
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={handleClose}
              >
                <MenuItem onClick={leaveRoom}>Raum verlassen</MenuItem>
              </Menu>
            </div>
            :
            <Avatar src="https://media.giphy.com/media/jP4r7ai80AsEMAVYLo/giphy.gif" alt="Corona Cat"/>
          }
        </Toolbar>
      </AppBar>
      {!hideBreadcrumbs &&
      <Breadcrumbs aria-label="breadcrumb" style={{ margin: 10 }}>
        {room?.exists &&
        <Link href="/room">
          <Chip label={room?.get('name')} icon={<MeetingRoomTwoTone/>}/>
        </Link>
        }
        {game?.exists &&
        <Link href={`/room/game/${game.get('index')}`}>
          <Chip label={`Spiel ${game.get('index')}`} icon={<GameStatusIcon/>}/>
        </Link>
        }
        {game?.exists && round &&
        <Link href={`/room/game/${game.get('index')}/round/${round.index}`}>
          <Chip label={`Runde ${round.index}`} icon={RoundStatusIcon && <RoundStatusIcon/>}/>
        </Link>
        }
      </Breadcrumbs>
      }
      {children}
      
    </Container>
  );
};

export default Screen;
